// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__AoFYL","modal":"Modal_modal__i0TOf","closeButton":"Modal_closeButton__VgzNN","icon":"Modal_icon__g_NNm"};